module.exports = "<p>\n  notification works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/notification/notification.component.html
// module id = ../../../../../src/app/event/notification/notification.component.html
// module chunks = main